import request from '@/utils/request'

// 查询员工日志列表
export function listUserLog(query) {
  return request({
    url: '/system/user-log/list',
    method: 'get',
    params: query,
  })
}

// 查询员工日志分页
export function pageUserLog(query) {
  return request({
    url: '/system/user-log/page',
    method: 'get',
    params: query,
  })
}

// 查询员工日志详细
export function getUserLog(data) {
  return request({
    url: '/system/user-log/detail',
    method: 'get',
    params: data,
  })
}

// 新增员工日志
export function addUserLog(data) {
  return request({
    url: '/system/user-log/add',
    method: 'post',
    data: data,
  })
}

// 修改员工日志
export function updateUserLog(data) {
  return request({
    url: '/system/user-log/edit',
    method: 'post',
    data: data,
  })
}

// 删除员工日志
export function delUserLog(data) {
  return request({
    url: '/system/user-log/delete',
    method: 'post',
    data: data,
  })
}
